import { render, staticRenderFns } from "./Guan.vue?vue&type=template&id=6b50a4a9&scoped=true"
import script from "./Guan.vue?vue&type=script&lang=js"
export * from "./Guan.vue?vue&type=script&lang=js"
import style0 from "./Guan.vue?vue&type=style&index=0&id=6b50a4a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b50a4a9",
  null
  
)

export default component.exports